/* Zap! Creatives tutorial enhancement. Article content remains the source of truth. */
(function () {
  const slug = text => text.toLowerCase().normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'step';

  function initArticle(article) {
    const content = article.querySelector('[data-zt-content]');
    if (!content || content.dataset.ztReady === 'true') return;
    const headings = Array.from(content.children).filter(el => el.tagName === 'H2');
    if (!headings.length) return;

    const ids = new Set();
    headings.forEach(heading => {
      const base = heading.id || 'step-' + slug(heading.textContent);
      let id = base;
      let suffix = 2;
      while (ids.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = base + '-' + suffix++;
      }
      heading.id = id;
      ids.add(id);
    });

    const fragment = document.createDocumentFragment();
    let group = null;
    let stepNumber = 0;
    Array.from(content.childNodes).forEach(node => {
      if (node.nodeType === 1 && node.tagName === 'H2') {
        stepNumber++;
        group = document.createElement('section');
        group.className = 'zap-tutorial__step';
        group.setAttribute('aria-labelledby', node.id);
        const headingWrap = document.createElement('div');
        headingWrap.className = 'zap-tutorial__step-heading';
        const number = document.createElement('span');
        number.className = 'zap-tutorial__step-number';
        number.textContent = String(stepNumber);
        number.setAttribute('aria-hidden', 'true');
        headingWrap.append(number, node);
        group.appendChild(headingWrap);
        fragment.appendChild(group);
      } else if (group) {
        group.appendChild(node);
      } else {
        fragment.appendChild(node);
      }
    });
    content.replaceChildren(fragment);

    content.querySelectorAll('blockquote').forEach(quote => {
      quote.classList.add('zap-tutorial__tip');
    });

    const toc = article.querySelector('[data-zt-toc]');
    const list = article.querySelector('[data-zt-toc-list]');
    if (toc && list && headings.length > 1) {
      list.replaceChildren();
      headings.forEach(heading => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.hidden = false;
    }

    // An image within an ordinary link retains its existing link behavior.
    // Unlinked instructional images can be expanded via mouse, touch, Enter or Space.
    content.querySelectorAll('img').forEach(img => {
      if (img.closest('a,button') || img.classList.contains('zap-tutorial__lightbox-image')) return;
      img.classList.add('zap-tutorial__zoomable');
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', 'Enlarge image' + (img.alt ? ': ' + img.alt : ''));
      img.addEventListener('click', () => openImage(img));
      img.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openImage(img);
        }
      });
    });
    content.dataset.ztReady = 'true';
  }

  let lightbox = null;
  let previousFocus = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('dialog');
    lightbox.className = 'zap-tutorial__lightbox';
    lightbox.setAttribute('aria-label', 'Enlarged tutorial image');
    lightbox.innerHTML = '<div class="zap-tutorial__lightbox-inner"><button type="button" class="zap-tutorial__lightbox-close" aria-label="Close enlarged image">\u00d7</button><img class="zap-tutorial__lightbox-image" alt=""><p class="zap-tutorial__lightbox-caption"></p></div>';
    document.body.appendChild(lightbox);
    lightbox.querySelector('button').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('click', event => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('close', () => {
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
      previousFocus = null;
    });
    return lightbox;
  }

  function openImage(original) {
    const dialog = ensureLightbox();
    const image = dialog.querySelector('img');
    const caption = dialog.querySelector('.zap-tutorial__lightbox-caption');
    image.src = original.currentSrc || original.src;
    image.alt = original.alt || 'Tutorial illustration';
    caption.textContent = original.alt || '';
    caption.hidden = !original.alt;
    previousFocus = original;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('button').focus();
    } else {
      window.open(image.src, '_blank', 'noopener,noreferrer');
    }
  }

  function init() {
    document.querySelectorAll('[data-zap-tutorial]').forEach(initArticle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
